import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { ImageTextTriplets } from "../../../components/image-text-triplets";
import explainability from "../../../images/explainability.png";
import actionability from "../../../images/actionability.png";
import customization from "../../../images/customization.png";
import { MethodOverview } from "../../../components/method-overview";
import S2FC from "../../../images/Design_FactCheckerS2.png";
import S2EH from "../../../images/Design_EngagementHubS2.png";
import { CenteredCTA } from "../../../components/centered-cta";

export interface IConsolidationProps {
    sectionId: string;
    index: number;
    handleNavClick: (nav: string) => void;
}

export function Consolidation(props: IConsolidationProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section sectionId={props.sectionId} isLast={false}>
            <SectionHeader title={`${formattedIndex} Consolidation`} />
            <ParagraphGroup
                body={[
                    "Our overarching goal was to create a cohesive system of interventions, so our next step was to consolidate the features and incorporate user feedback. To guide our design process moving forward, we defined three main principles to ensure our solution would be effective in supporting user goals and building trust.",
                ]}
            />
            <ImageTextTriplets
                children={[
                    {
                        imgSrc: explainability,
                        title: "Explainability",
                        body:
                            "Users need to be able to understand how features work in order to establish enough trust to use them.",
                    },
                    {
                        imgSrc: actionability,
                        title: "Actionability",
                        body:
                            "Users want more action-oriented features that can be used to manage their engagement with misinformation.",
                    },
                    {
                        imgSrc: customization,
                        title: "Customization",
                        body:
                            "Users need to be able to understand how features work in order to establish enough trust to use them.",
                    },
                ]}
            />

            <CenteredCTA
                body="Check out our guidelines page for a more in-depth look at these principles."
                url="/guidelines"
                cta="View Guidelines"
                handleNavClick={props.handleNavClick}
            />

            <MethodOverview
                methods={[
                    {
                        title: "Fact-Checker",
                        body:
                            "In our second iteration of the prototype, we redesigned the fact-checker to include more prominent labels and underlines, which we color-coded based on categories of credibility. We also integrated a feedback mechanism that would give users a way to report errors should the fact-checker make any mistakes. While the visual indicators were more effective for participants evaluating credibility in-feed, the issue of trust and explainability remained. ",
                        imgSrc: S2FC,
                    },
                    {
                        title: "Engagement Hub",
                        body:
                            "We restructured the Activity Report to incorporate more action-oriented features, such as Corrections and the Feed Manager that were previously in-feed. While our prototype performed significantly better in terms of actionability, we ran into the problem of granularity: though some participants wanted to see which of the posts they engaged with had contained misinformation, others preferred taking action at the account or even feed level instead.",
                        imgSrc: S2EH,
                    },
                ]}
            />
        </Section>
    );
}
